
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/dashboard",
      function () {
        return require("private-next-pages/candidate/dashboard/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/dashboard"])
      });
    }
  